import React from 'react'

type TitleProps = {
  className?: string
  title: string
}
export const Title = ({ className, title }: TitleProps) => <h2 className={className}>{title}</h2>
